import {NgModule} from '@angular/core';
import {SourcesComponent} from '@feature/sources/sources.component';
import {AddSourceDialogComponent} from '@feature/sources/add-source-dialog/add-source-dialog.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SharedModule} from '@shared/shared.module';
import {CommonModule} from '@angular/common';
import {MatRadioModule} from '@angular/material/radio';
import {SecurityModule} from '@core/security/security.module';
import {TranslateModule} from '@ngx-translate/core';
import {SearchModule} from '@core/search/search.module';
import {FilterSourceDialogComponent} from '@feature/sources/filter-source-dialog/filter-source-dialog.component';
import {FormsModule} from '@angular/forms';
import {SourcesRoutingModule} from '@feature/sources/sources-routing.module';
import {HelpersModule} from '@shared/helpers/helpers.module';
import {PaginationModule} from '@component/pagination/pagination.module';
import {TemplateVarModule} from '@component/template-var/template-var.module';
import {LanguageDropdownModule} from '@component/language/dropdown/language-dropdown.module';
import {ContainerHeaderModule} from '@component/container-header/container-header.module';
import {AddSourceComponent} from '@feature/sources/add-source/add-source.component';

@NgModule({
    imports: [
        FlexLayoutModule,
        SharedModule,
        PaginationModule,
        CommonModule,
        SecurityModule,
        TranslateModule,
        SearchModule,
        FormsModule,
        MatRadioModule,
        SourcesRoutingModule,
        ContainerHeaderModule,
        HelpersModule,
        TemplateVarModule,
        LanguageDropdownModule,
    ],
    declarations: [
        AddSourceDialogComponent,
        FilterSourceDialogComponent,
        SourcesComponent,
        AddSourceComponent,
    ],
    exports: [
        AddSourceComponent,
    ],
})
export class SourcesModule {
}
